import React, { ChangeEvent, Component } from 'react';
import { Dialog } from 'primereact/dialog';
import Icon from '../../../icons/Icon';
import FormicaInput from '../../custom/FormicaInput';
import { AlertCommentLog, WatchlistAlertDomains } from '../../../domain/watchlist/WatchlistAlertDomains';
import { RootState } from '../../../redux/store';
import { FormicaProps, withFormica } from '../../../helpers/withFormica';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import { InstanceContainer } from '../../../config/binding/InstanceBinding';
import Injectables from '../../../constant/Injectables';
import { query, repository, subscribe } from '@trlogic/client-js';
import _ from 'lodash';
import NavigationUtil from '../../../util/NavigationUtil';
import moment from 'moment';
import { Loading } from '@trlogic/ui-pack';
import WatchlistService from '../../../service/WatchlistService';
import ServiceContainer from '../../../config/ServiceContainer';
import { ServiceNames } from '../../../constant/ServiceNames';
import QueryBuilder = query.QueryBuilder;
import eq = query.eq;
import and = query.and;

let messagesEndRef: any = null;

class WatchlistAlertCommentComponent extends Component<Props, State> {
  public state: State = new State();
  private repository: repository.ReadOnlyQueryableRepository = InstanceContainer.get(Injectables.REPOSITORY);
  private watchlistService: WatchlistService = ServiceContainer.getInstance().get(ServiceNames.WATCHLIST);

  private commentSubscription: subscribe.Subscription | undefined;
  private computation: subscribe.Computation | undefined;

  render() {
    const { commentModalVisible, closeCommand } = this.props;
    return (
      <Dialog
        header={this.getHeader}
        className={'case-attachment w-1/3 h-1/2'}
        visible={commentModalVisible}
        onHide={closeCommand}
        closable={false}
        closeOnEscape={true}
        dismissableMask={true}
      >
        {this.getContent()}
      </Dialog>
    );
  }

  public componentDidMount(): void {
    this.startTracker();
  }

  public async componentWillUnmount() {
    this.stopTracker();
  }

  private startTracker = (): void => {
    const endpoint = this.getEndpoint();
    const _query = this.getQuery();
    this.commentSubscription = subscribe.Formica.subscribe(endpoint, _query, undefined, 'elasticsearch');
    this.computation = subscribe.Tracker.autorun(this.tracker, [this.commentSubscription]);
  };

  private stopTracker = () => {
    this.commentSubscription?.stop();
    this.computation?.stop();
  };

  private tracker = async () => {
    if (this.commentSubscription?.ready()) {
      await this.buildCommentLog();
    }
  };

  private scrollToBottom = () => {
    messagesEndRef?.scrollIntoView({ behavior: 'smooth' });
  };

  private onChangeComment = (event: ChangeEvent<HTMLInputElement>) => {
    this.setState({ comment: event.target.value });
  };

  private handleKeyPress = (event: any) => {
    if (event.key === 'Enter') {
      void this.sendComment();
    }
  };

  private sendComment = async () => {
    const { comment } = this.state;
    const { kycLogData } = this.props;
    if (comment == undefined || comment.trim().length == 0 || kycLogData?.id == undefined) return;
    this.setState({ commentLoading: true });
    try {
      await this.watchlistService.sendComment(kycLogData?.id, comment);
      this.setState({ comment: '' });
    } catch (e) {
      console.error(e);
    } finally {
      this.setState({ commentLoading: false });
    }
  };

  private buildCommentLog = async () => {
    const { kycLogData, setCommentCount } = this.props;
    const endpoint = this.getEndpoint();
    const _query = QueryBuilder.select()
      .from(endpoint)
      .where(and(eq('alertId', kycLogData?.id), eq('type', 'COMMENT')))
      .orderBy({
        field: 'timestamp',
        operator: 'ASC',
      })
      .build();
    const attachments = await this.repository.findMany<AlertCommentLog>(_query);
    if (!_.isEqual(attachments, this.state.attachments)) {
      this.setState({ attachments: attachments });
      setCommentCount(attachments.length);
    }
  };

  private getEndpoint = () => {
    return `kyc_alert_log_${NavigationUtil.getTenant()}_*`;
  };

  private getQuery = () => {
    const { kycLogData } = this.props;
    const endpoint = this.getEndpoint();
    return QueryBuilder.select()
      .from(endpoint)
      .limit(1000)
      .where(and(eq('alertId', kycLogData?.id), eq('type', 'COMMENT')))
      .orderBy({
        field: 'timestamp',
        operator: 'ASC',
      })
      .build();
  };

  private getHeader = () => {
    return (
      <div className={'bg-[#333333] h-[54px] rounded-t-[6px] flex items-center justify-between align-center pl-[20px] pr-[20px]'}>
        <div className={'flex items-center justify-start align-center w-full lg:w-auto gap-2'}>
          <div className={'bg-white rounded-full w-[34px] h-[34px] min-h-[34px] min-w-[34px] shrink-0 flex justify-center align-center'}>
            <div className={'text-f-purple'}>
              <Icon icon={'comment'} size={20} />
            </div>
          </div>
          <div className={'text-white font-medium text-md'}>Comment</div>
        </div>
        <div
          className={'bg-white w-5 h-5 rounded-[4px] flex items-center justify-center border-[0.8px] border-[#E0E4E8] hover:bg-f-gray active:border-[#458EF7] hover:cursor-pointer z-50'}
          onClick={this.exportToCSV}
        >
          <div className={'w-3 h-3 flex items-center justify-center'}>
            <Icon icon={"export"}/>
          </div>
        </div>
      </div>
    );
  };

  private exportToCSV = () => {

    const {attachments} = this.state;
    const {kycLogData} = this.props;

    if (!attachments || attachments.length === 0 || !kycLogData?.id) {
      return;
    }
    const headers: string[] = [
      'Timestamp',
      'Type',
      'User',
      'Content',
      'Alert ID'
    ];
    const csvRows: string[] = [headers.join(',')];

    attachments.forEach((attachment): void => {
      const row: string[] = [
        attachment.timestamp ? moment(attachment.timestamp).format('YYYY-MM-DD HH:mm:ss') : '',
        attachment.type || '',
        attachment.username || '',
        attachment.content ? `"${attachment.content.replace(/"/g, '""')}"` : '',
        kycLogData.id || ''
      ];
      csvRows.push(row.join(','));
    });

    const csvContent: string = csvRows.join('\n');
    const blob = new Blob([csvContent], {type: 'text/csv;charset=utf-8;'});
    const link = document.createElement('a');

    if (link.download !== undefined) {
      const url: string = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', `watchlist_alert_comments_${kycLogData.id}_${moment().valueOf()}.csv`);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }

  private getContent = () => {
    const { attachments, comment, commentLoading } = this.state;
    const { user } = this.props;
    return (
      <div className={'w-full h-full'}>
        <div className={'pb-10 flex-grow overflow-y-auto'}>
          {attachments.map((a) => (
            <div
              key={a.id || a.timestamp}
              className={`flex rounded-[10px] w-2/3 shadow bg-white p-2 my-4 items-center gap-2 ${user.username === a.username ? 'ml-auto' : 'mr-auto'}`}
            >
              <div className={'flex justify-center align-center bg-[#D7E5FF] rounded-full w-[26px] h-[26px] min-h-[26px] min-w-[26px] shrink-0 '}>
                <div className={'text-f-purple'}>
                  <Icon icon={'people'} size={16} color={'white'} />
                </div>
              </div>
              <div className={'flex flex-col flex-grow'}>
                <div className={'flex justify-between'}>
                  <div className={'flex-grow text-xs text-[#6CA2FF]'}>{a.username}</div>
                  <div className={'text-[#333333] text-2xs font-extralight'}>{moment(a.timestamp).format('LLLL').valueOf()}</div>
                </div>
                <div className={'flex-grow overflow-auto text-[#4F4F4F] text-md'}>{a.content}</div>
              </div>
            </div>
          ))}
          <div
            ref={(el) => {
              messagesEndRef = el;
              this.scrollToBottom();
            }}
          />
        </div>
        <div className={'flex gap-2 p-2 absolute bottom-0 left-0 w-full'}>
          <FormicaInput value={comment} onChange={this.onChangeComment} disabled={commentLoading} onKeyPress={this.handleKeyPress} />
          <div
            className={`cursor-pointer bg-white border rounded w-[34px] h-[34px] min-h-[34px] min-w-[34px] shrink-0 flex items-center justify-center align-center text-f-purple `}
            onClick={this.sendComment}
          >
            {commentLoading ? <Loading /> : <Icon icon={'deploy'} size={20} color={'#284564'} />}
          </div>
        </div>
      </div>
    );
  };
}

class State {
  comment: string = '';
  commentLoading: boolean = false;
  attachments: AlertCommentLog[] = [];
}

interface Props extends ReduxProps, FormicaProps {
  commentModalVisible: boolean;
  closeCommand: () => void;
  kycLogData: WatchlistAlertDomains | undefined;
  setCommentCount: (count: number) => void;
}

const mapStateToProps = (state: RootState) => ({
  user: state.auth.user,
});
const connector = connect(mapStateToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default withFormica(connector(WatchlistAlertCommentComponent));
